import(/* webpackMode: "eager" */ "/Users/ataturkoglu/Documents/Pomza Export/pomzaexport_next/src/app/[locale]/facilities/page.jsx");
